// This is the 'First Call' phone number for the At-Need team
export const PHONE = "+18449052639";
export const CARE_EMAIL = "care@after.com";

// This is the shared email address for the At-Need care team
export const CARE_TEAM_EMAIL = "care@after.com";

export const CONSULTATION_CAL_LINK = "team/after/care-consultation";

// Extended care daily fee for refrigeration beyond included days
export const EXTENDED_CARE_DAILY_FEE = 75;

// Fallback weight threshold (lbs) when backend tier data is unavailable
export const WEIGHT_THRESHOLD_LBS = 300;

// Maximum death certificates the customer can order (matches after-internal pricing schema)
export const MAX_DEATH_CERTIFICATES = 50;

// Canonical at-need case stage slugs in the order they progress through.
// Source of truth for any frontend logic that needs to reference a stage by
// name — keep in sync with after-internal's case stage definitions.
export const STAGES = [
  "Lead",
  "Case Secured",
  "Dispatch",
  "Care",
  "Docs",
  "Vitals & Permit",
  "Fulfillment",
  "DC Ordered",
  "Cremation",
  "Delivery",
  "Complete",
] as const;

export type Stage = (typeof STAGES)[number];

// Stages where a case contact may reach the arrangement flow at all —
// the single gating set shared by Basecamp and the arrangement route guard
// so the two can never disagree.
// Includes Docs because sending the Imminent Cremation Authorization
// before the arrangement is finalized is a legitimate workflow, so the
// family must still be able to finish their arrangement there.
export const STAGES_WITH_ARRANGEMENT_ACCESS: readonly Stage[] = [
  "Dispatch",
  "Care",
  "Docs",
];

// Arrangement record status stored at app-data
// properties.arrangement.status.
export type ArrangementStatus = "draft" | "submitted" | "completed";

// Stages up to and including Care. Anything outside this list represents
// a case that has progressed past Care — vitals is no longer expected from
// the family and the arrangement decision window has closed.
export const STAGES_UP_TO_CARE: readonly Stage[] = [
  "Lead",
  "Case Secured",
  "Dispatch",
  "Care",
];
